import { isObject } from "utils/helper/type";
import { Column } from "../Column/Column";
import { SortOrder } from "../constants";
import { ColumnDefinition, TableSort } from "../types";

export interface RenderColumnsProps {
  columns: (string | ColumnDefinition)[];
  isSubTable?: boolean;
  sort?: TableSort;
  setSort?: (sort: TableSort) => void;
}

export const RenderColumns = ({ columns, isSubTable, sort, setSort }: RenderColumnsProps) => {
  const renderColumns: any[] = columns.map((column) => isObject(column) ? ({
    ...column,
    sortable: column.sortable ?? false,
    sortKey: column.sortKey ?? undefined,
    activeSort: column.sortKey === sort?.column,
  }) : { name: column });

  return (
    <>
      {renderColumns.map((column, index) => (
        <th
          className={`px-2 py-4 text-start first:px-3 last:px-3 ${column.name === 'Actions' && 'border-l border-gray-line'} ${isSubTable && '!py-2'} `}
          key={index}>
          <Column
            name={column.name}
            sortable={column.sortable}
            sortOrder={column.activeSort ? sort?.order : SortOrder.NONE}
            onSortChange={(order) => setSort?.({ column: column.sortKey, order })}
            isAllSelected={column.isAllSelected}
            isAllDisabled={column.isAllDisabled}
            toggleAllSelected={column.toggleAllSelected}
            indeterminate={column.indeterminate}
            tooltipText={column.tooltipText}
          />
        </th>
      ))}
    </>
  );
};
